export default "__VITE_ASSET__DMS71Mbw__"